// extracted by mini-css-extract-plugin
export default {"container":"C8QeFnE9zgYZ3uBrI7ZL","label":"hey095TEr0mUqOnRmuFp","secondaryText":"gQeafbbxbInLVjNYTUDf","editButton":"SZkrrtsdHPY0gqynFZb6"};